import { render, staticRenderFns } from "./editHelpDocument.vue?vue&type=template&id=46e2bfe3&scoped=true&"
import script from "./editHelpDocument.vue?vue&type=script&lang=js&"
export * from "./editHelpDocument.vue?vue&type=script&lang=js&"
import style0 from "./editHelpDocument.vue?vue&type=style&index=0&id=46e2bfe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2bfe3",
  null
  
)

export default component.exports